import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { DarkModeContextProvider } from "./context/darkModeContext";
import { SidebarProvider } from './context/SidebarContext';


ReactDOM.render(
  <React.StrictMode>
    <DarkModeContextProvider>
      <SidebarProvider>
      <App />
      </SidebarProvider>
    </DarkModeContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
